'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface LanguageSwitcherProps {
  className?: string;
}

const LanguageSwitcher = ({ className = '' }: LanguageSwitcherProps) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState('fr');
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
    const savedLanguage = localStorage.getItem('preferredLanguage') || 'fr';
    setCurrentLanguage(savedLanguage);
  }, []);

  const handleLanguageChange = (lang: string) => {
    if (isHydrated) {
      setCurrentLanguage(lang);
      localStorage.setItem('preferredLanguage', lang);
      setIsOpen(false);
      window.location.reload();
    }
  };

  const languages = [
    { code: 'fr', label: 'Français', flag: '🇫🇷' },
    { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  ];

  const currentLang = languages.find((lang) => lang.code === currentLanguage) || languages[0];

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 bg-surface hover:bg-card border border-border rounded-lg transition-all duration-300"
        aria-label="Change language"
      >
        <span className="text-xl">{currentLang.flag}</span>
        <span className="text-sm font-medium text-foreground">{currentLang.code.toUpperCase()}</span>
        <Icon
          name={isOpen ? 'ChevronUpIcon' : 'ChevronDownIcon'}
          size={16}
          variant="outline"
          className="text-muted-foreground"
        />
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 mt-2 w-48 bg-card border border-border rounded-lg shadow-xl overflow-hidden z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`w-full flex items-center gap-3 px-4 py-3 hover:bg-surface transition-colors duration-300 ${
                currentLanguage === lang.code ? 'bg-primary/10' : ''
              }`}
            >
              <span className="text-xl">{lang.flag}</span>
              <span className="text-sm font-medium text-foreground">{lang.label}</span>
              {currentLanguage === lang.code && (
                <Icon name="CheckIcon" size={16} variant="solid" className="text-primary ml-auto" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;